import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "admin-lte/dist/css/adminlte.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

// Initialize Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTachometerAlt,
  faBarcode,
  faExchangeAlt,
  faCog,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faUserCircle,
  faChartBar,
  faSignOutAlt,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "contexts/AuthContext";
import DrawerProvider from "contexts/TradingChartProvider";
import TradingChartProvider from "contexts/TradingChartProvider";

library.add(
  faTachometerAlt,
  faBarcode,
  faExchangeAlt,
  faCog,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faUserCircle,
  faChartBar,
  faSignOutAlt,
  faBars
);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TradingChartProvider>
          <App />
        </TradingChartProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
